import React, { useState, useEffect } from "react";
import "./ErrorNotification.css";

const ErrorNotification = ({ errors, width, marginBottom, marginLeft }) => {
  const [showErrors, setShowErrors] = useState(false);

  // Normalize any value to a display string
  const normalizeError = (error) => {
    if (!error) return "";
    if (Array.isArray(error)) return error.join(", ");
    return String(error);
  };

  const getNormalizedErrorObj = (err) => {
    if (!err) return {};
    if (typeof err === "string") return { general: err };
    if (typeof err === "object" && !Array.isArray(err)) return err;
    return {};
  };

  const normalizedErrorObj = getNormalizedErrorObj(errors);

  useEffect(() => {
    const hasErrors =
      normalizedErrorObj &&
      Object.keys(normalizedErrorObj).length > 0 &&
      Object.values(normalizedErrorObj).some((error) => normalizeError(error).trim() !== "");

    setShowErrors(hasErrors);
  }, [errors]);

  if (!showErrors) return null;

  const containerStyle = {
    width: width || "auto",
    ...(marginLeft !== undefined && { marginLeft }),
    ...(marginBottom !== undefined && { marginBottom }),
  };

  return (
    <div className="error-notification-container" style={containerStyle}>
      <div className="error-list">
        {Object.entries(normalizedErrorObj).map(([field, message]) => {
          const normalized = normalizeError(message);
          if (!normalized.trim()) return null;

          const cleanField = field.replace(/_\d+$/, "");
          const isGeneral = cleanField.toLowerCase() === "general";

          return (
            <div key={field} className="error-item fts-12">
              {!isGeneral && (
                <span className="error-field-name fts-12">
                  {cleanField
                    .replace(/([a-z])([A-Z])/g, "$1 $2")
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase())
                    .replace("Income Expense Type", "Income/Expense Type")}
                  :
                </span>
              )}{" "}
              <span className="error-message">{normalized}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ErrorNotification;